import React from 'react';

import { Navigate,Route } from 'react-router-dom';

import { ERouteContext, ESharedRoutes } from 'routes/types';
import BuilderView from 'views/Builder/BuilderView';
import ContentView from 'views/Content/ContentView';
import PagesView from 'views/Pages/PagesView';

import { getSharedRoutes } from './utils/sharedRoutesUtil';

const portalLevelRoutes = () => (
  <Route path="portal/:portalId/*">
    <React.Fragment key="players-routes">
      {getSharedRoutes(ESharedRoutes.PLAYERS)}
    </React.Fragment>
    <React.Fragment key="localization-routes">
      {getSharedRoutes(ESharedRoutes.LOCALIZATION)}
    </React.Fragment>
    <React.Fragment key="settings-routes">
      {getSharedRoutes(ESharedRoutes.SETTINGS, ERouteContext.PORTAL)}
    </React.Fragment>
    <Route path="builder/*" element={<BuilderView />} />
    <Route path="pages/*" element={<PagesView />} />
    <Route path="content/*" element={<ContentView />} />
  </Route>
);

export default portalLevelRoutes;
